import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { TABLE__empty } from '@/pages/_base/table/TABLE__empty';

import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { ENUM__field_group_type } from '@shared/dto/generation/graph_invoke/_fields/_base/_methods/ENUM__field_group_type';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { FIELD__list_lora } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_lora';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { useMemo } from 'react';
import { G_TABLE__inputs__image_asset } from './image/G_TABLE__inputs__image_asset';
import { G_TABLE__inputs__image_asset_list } from './image/G_TABLE__inputs__image_asset_list';
import { G_TABLE__inputs__model } from './model/G_TABLE__inputs__model';
import { G_TABLE__inputs__model_lora } from './model_lora/G_TABLE__inputs__model_lora';
import { G_TABLE__inputs__token_list } from './token/G_TABLE__inputs__token_list';

export function G_TABLE__inputs_master() {
  /*
   *
   */
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_inputs__filter } = use_slice_ui(['g_inputs__filter']);

  if (generation_current.is_stub()) return <></>;

  //key - id
  let fields_map = useMemo(() => generation_current.tool.graph.fields__get_map(), [generation_current]);

  /*
   *
   */

  /*
   *
   */

  function render_table_all() {
    let out_list = [];

    out_list.push(render_table_images());
    out_list.push(render_table_images_list());
    // out_list.push(render_table_list_of_images());
    out_list.push(render_table_models());
    out_list.push(render_table_models_lora());
    out_list.push(render_table_primitives());
    out_list.push(render_table_tokens_list());

    out_list = out_list.filter(item => item !== null);

    if (out_list.is_empty()) return <TABLE__empty />;

    return out_list;
  }

  function render_table_images() {
    if (!g_inputs__filter.field_group_type.has(ENUM__field_group_type.IMAGES)) return null;

    let fields = fields_map.values().filter(field => field instanceof FIELD__image_asset);

    fields = g_inputs__filter.filter__all(fields, generation_current.tool.graph);

    if (fields.is_empty()) return null;

    return <G_TABLE__inputs__image_asset key={'table_inputs__image'} {...{ fields }} />;
  }

  function render_table_images_list() {
    if (!g_inputs__filter.field_group_type.has(ENUM__field_group_type.IMAGES)) return null;

    let fields = fields_map.values().filter(field => field instanceof FIELD__list_image_asset);

    fields = g_inputs__filter.filter__all(fields, generation_current.tool.graph);

    if (fields.is_empty()) return null;

    return <G_TABLE__inputs__image_asset_list key={'table_inputs__image_list'} {...{ fields }} />;
  }

  function render_table_models() {
    if (!g_inputs__filter.field_group_type.has(ENUM__field_group_type.MODELS)) return null;

    let fields = fields_map.values().filter(field => field instanceof FIELD_PRIMITIVE__string_hash_ml_asset);
    fields = fields.filter(field => field.ml_asset_type != ENUM__ml_asset_type.LORA);

    fields = g_inputs__filter.filter__all(fields, generation_current.tool.graph);

    if (fields.is_empty()) return null;

    return <G_TABLE__inputs__model key={'table_inputs__model'} {...{ fields }} />;
  }

  function render_table_models_lora() {
    if (!g_inputs__filter.field_group_type.has(ENUM__field_group_type.MODELS)) return null;

    let fields = fields_map.values().filter(field => field instanceof FIELD__list_lora);

    fields = g_inputs__filter.filter__all(fields, generation_current.tool.graph);

    if (fields.is_empty()) return null;

    return <G_TABLE__inputs__model_lora key={'table_inputs__model_lora'} {...{ fields }} />;
  }

  function render_table_primitives() {
    return null;
  }

  function render_table_tokens_list() {
    if (!g_inputs__filter.field_group_type.has(ENUM__field_group_type.TOKENS)) return null;

    let fields = fields_map.values().filter(field => field instanceof FIELD__list_token);

    fields = g_inputs__filter.filter__all(fields, generation_current.tool.graph);

    if (fields.is_empty()) return null;

    return <G_TABLE__inputs__token_list key={'table_inputs__tokens_list'} {...{ fields }} />;
  }

  /*
   *
   */

  return <div className="size-full bg-component overflow-y-auto">{render_table_all()}</div>;
}
